import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { SettingsService } from 'src/app/settings/services/settings.service';
import { IOsiWaiverTourcodeConfig } from 'src/app/core/models/agency-settings.model';
import { TOURCODE_VALIDATORS } from 'src/app/core/enums/enums';

@Component({
  selector: 'app-sync-ticket-form',
  templateUrl: './sync-ticket-form.component.html'
})
export class SyncTicketFormComponent implements OnInit, OnDestroy {
  @Input() open: boolean;
  @Input() isReIssueFlow = false;

  @Output() closeSyncForm = new EventEmitter<boolean>();

  subscriptions = new Subscription();

  isAirline: boolean = false;
  form: UntypedFormGroup;
  isSynchronized: number = null;
  aditionalFieldsConfig: IOsiWaiverTourcodeConfig = null;
  OPTIONS = [
    { name: 'yes', code: 1 },
    { name: 'no', code: 0 }
  ];
  OPTIONS_REISSUE_FLOW = [
    { name: 'yes', code: 0 },
    { name: 'no', code: 1 }
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private service: ItineraryService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.buildForm();
    this.validateAditionalFields();
    this.settingsService.getClientIsAirline().subscribe((resultParameterAirline) => {
      this.isAirline = resultParameterAirline;
    });
  }

  buildForm() {
    this.form = this.fb.group({
      waiver: [''],
      tourCode: [''],
      osis: this.fb.array([])
    });
  }

  validateAditionalFields() {
    this.settingsService.getClientSettings().subscribe((settings) => {
      this.aditionalFieldsConfig = {
        osiEnabled: settings?.exchangeAdditionalFields?.scheduleExchange?.osiEnabled,
        waiverEnabled: settings?.exchangeAdditionalFields?.scheduleExchange?.waiverEnabled,
        tourcodeEnabled: settings?.exchangeAdditionalFields?.scheduleExchange?.tourcodeEnabled
      };
    });
  }

  osis(): UntypedFormArray {
    return this.form.get('osis') as UntypedFormArray;
  }

  addOsi(value: string) {
    const osis = this.form.controls.osis as UntypedFormArray;
    !!value && osis.push(this.fb.control(value));
  }

  deleteOsi(index: number) {
    const osis = this.form.controls.osis as UntypedFormArray;
    osis.removeAt(index);
  }

  confirmRescheduledItinerary() {
    if (this.form.valid && this.isSynchronized >= 0) {
      const params = {
        isSynchronized: this.isSynchronized,
        ...this.form.value
      };
      this.service.navigateTo(`/involuntary-change/airline-option`, params);
    }
  }

  validateTourcode(): boolean {
    if (this.form.controls.tourCode.value === '' || this.form.controls.tourCode.value === null) {
      return false
    } else {
      return this.form.controls.tourCode.value
        ? !this.form.controls.tourCode.value.toLowerCase().startsWith(TOURCODE_VALIDATORS.MXLA)
        : true;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
